<template>
	<div class="body">
		<Header></Header>
		<div class="block">
			<div class="banner_news"></div>
			<div class="menu_block">
				<div class="content fsb">
					<dl class="menu_slt">
						<dd :class="type == 'news_1' ? 'select' : ''" @click="changeTab('news_1')">公司新闻</dd>
						<dd :class="type == 'news_2' ? 'select' : ''" @click="changeTab('news_2')">行业资讯</dd>
					</dl>
					<div class="location">
						当前位置：
						<a href="/">首页</a>
						<i class="icon el-icon-arrow-right"></i>
						<a href="">新闻中心</a>
					</div>
				</div>
			</div>

			<!-- 公司新闻 -->
			<div class="content"  v-if="type == 'news_1'">
				<div class="title_01 mt70">公司新闻</div>

				<ul class="news_list">
					<li>
                        <img src="../images/news/zhongshihua.jpeg" alt="" style="width: 433px;height: 312px;box-shadow: 2px 2px 2px 2px rgba(0,0,0,0.5);"/>
						<div class="info">
							<span>2022.08.19</span>
							<p>我司进入中石化供应商体系</p>
							<a class="more" href="/detail1" target="_blank">
								<i class="icon el-icon-arrow-right"></i>
								了解更多
							</a>
						</div>
					</li>
                    <li>
                        <img src="../images/news/yunpingtai.png" alt="" style="width: 433px;height: 312px;box-shadow: 2px 2px 2px 2px rgba(0,0,0,0.5);"/>
                        <div class="info">
                            <span>2023.05.20</span>
                            <p>中喆德元电机云平台上线</p>
                            <a class="more" href="/detail2" target="_blank">
                                <i class="icon el-icon-arrow-right"></i>
                                了解更多
                            </a>
                        </div>
                    </li>
<!--					<li>-->
<!--						<img src="../images/img/img_03.png" alt="" />-->
<!--						<div class="info">-->
<!--							<span>2022.01.12</span>-->
<!--							<p>高效本体激励电机转子结构,安装方法及电机</p>-->
<!--							<a class="more" href="" target="_blank">-->
<!--								<i class="icon el-icon-arrow-right"></i>-->
<!--								了解更多-->
<!--							</a>-->
<!--						</div>-->
<!--					</li>-->
<!--					<li>-->
<!--						<img src="../images/img/img_03.png" alt="" />-->
<!--						<div class="info">-->
<!--							<span>2022.01.12</span>-->
<!--							<p>高效本体激励电机转子结构,安装方法及电机</p>-->
<!--							<a class="more" href="" target="_blank">-->
<!--								<i class="icon el-icon-arrow-right"></i>-->
<!--								了解更多-->
<!--							</a>-->
<!--						</div>-->
<!--					</li>-->
<!--					<li>-->
<!--						<img src="../images/img/img_03.png" alt="" />-->
<!--						<div class="info">-->
<!--							<span>2022.01.12</span>-->
<!--							<p>高效本体激励电机转子结构,安装方法及电机</p>-->
<!--							<a class="more" href="" target="_blank">-->
<!--								<i class="icon el-icon-arrow-right"></i>-->
<!--								了解更多-->
<!--							</a>-->
<!--						</div>-->
<!--					</li>-->
<!--					<li>-->
<!--						<img src="../images/img/img_03.png" alt="" />-->
<!--						<div class="info">-->
<!--							<span>2022.01.12</span>-->
<!--							<p>高效本体激励电机转子结构,安装方法及电机</p>-->
<!--							<a class="more" href="" target="_blank">-->
<!--								<i class="icon el-icon-arrow-right"></i>-->
<!--								了解更多-->
<!--							</a>-->
<!--						</div>-->
<!--					</li>-->
<!--					<li>-->
<!--						<img src="../images/img/img_03.png" alt="" />-->
<!--						<div class="info">-->
<!--							<span>2022.01.12</span>-->
<!--							<p>高效本体激励电机转子结构,安装方法及电机</p>-->
<!--							<a class="more" href="" target="_blank">-->
<!--								<i class="icon el-icon-arrow-right"></i>-->
<!--								了解更多-->
<!--							</a>-->
<!--						</div>-->
<!--					</li>-->
				</ul>

<!--				<div class="page_list">-->
<!--					<el-pagination-->
<!--						:page-size="20"-->
<!--						:pager-count="11"-->
<!--						layout="prev, pager, next"-->
<!--						:total="100"-->
<!--					></el-pagination>-->
<!--				</div>-->
			</div>

			<!-- 行业资讯 -->

			<div class="content"  v-if="type == 'news_2'">
				<div class="title_01 mt70">行业资讯</div>
				<ul class="news_list">
<!--					<li>-->
<!--						<img src="../images/img/img_03.png" alt="" />-->
<!--						<div class="info">-->
<!--							<span>2022.01.12</span>-->
<!--							<p>高效本体激励电机转子结构,安装方法及电机</p>-->
<!--							<a class="more" href="" target="_blank">-->
<!--								<i class="icon el-icon-arrow-right"></i>-->
<!--								了解更多-->
<!--							</a>-->
<!--						</div>-->
<!--					</li>-->
<!--					<li>-->
<!--						<img src="../images/img/img_03.png" alt="" />-->
<!--						<div class="info">-->
<!--							<span>2022.01.12</span>-->
<!--							<p>高效本体激励电机转子结构,安装方法及电机</p>-->
<!--							<a class="more" href="" target="_blank">-->
<!--								<i class="icon el-icon-arrow-right"></i>-->
<!--								了解更多-->
<!--							</a>-->
<!--						</div>-->
<!--					</li>-->
<!--					<li>-->
<!--						<img src="../images/img/img_03.png" alt="" />-->
<!--						<div class="info">-->
<!--							<span>2022.01.12</span>-->
<!--							<p>高效本体激励电机转子结构,安装方法及电机</p>-->
<!--							<a class="more" href="" target="_blank">-->
<!--								<i class="icon el-icon-arrow-right"></i>-->
<!--								了解更多-->
<!--							</a>-->
<!--						</div>-->
<!--					</li>-->
<!--					<li>-->
<!--						<img src="../images/img/img_03.png" alt="" />-->
<!--						<div class="info">-->
<!--							<span>2022.01.12</span>-->
<!--							<p>高效本体激励电机转子结构,安装方法及电机</p>-->
<!--							<a class="more" href="" target="_blank">-->
<!--								<i class="icon el-icon-arrow-right"></i>-->
<!--								了解更多-->
<!--							</a>-->
<!--						</div>-->
<!--					</li>-->
<!--					<li>-->
<!--						<img src="../images/img/img_03.png" alt="" />-->
<!--						<div class="info">-->
<!--							<span>2022.01.12</span>-->
<!--							<p>高效本体激励电机转子结构,安装方法及电机</p>-->
<!--							<a class="more" href="" target="_blank">-->
<!--								<i class="icon el-icon-arrow-right"></i>-->
<!--								了解更多-->
<!--							</a>-->
<!--						</div>-->
<!--					</li>-->
<!--					<li>-->
<!--						<img src="../images/img/img_03.png" alt="" />-->
<!--						<div class="info">-->
<!--							<span>2022.01.12</span>-->
<!--							<p>高效本体激励电机转子结构,安装方法及电机</p>-->
<!--							<a class="more" href="" target="_blank">-->
<!--								<i class="icon el-icon-arrow-right"></i>-->
<!--								了解更多-->
<!--							</a>-->
<!--						</div>-->
<!--					</li>-->
				</ul>

<!--				<div class="page_list">-->
<!--					<el-pagination-->
<!--						:page-size="20"-->
<!--						:pager-count="11"-->
<!--						layout="prev, pager, next"-->
<!--						:total="100"-->
<!--					></el-pagination>-->
<!--				</div>-->
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from '../components/hearder.vue'
import Footer from '../components/footer.vue'
export default {
	data() {
		return {
			type: 'news_1'
		}
	},
	components: {
		Header,
		Footer
	},
	methods: {
		// 切换
		changeTab(name) {
			this.type = name
		}
	}
}
</script>

<style lang="less" scoped>
.news_list {
	width: 100%;
	display: flex;
	flex-wrap: wrap;

	li {
		width: 440px;
		background: #f9f9f9;
		margin-top: 50px;
		margin-right: 30px;

		&:nth-child(3n) {
			margin-right: 0px;
		}

		img {
			width: 100%;
			height: 280px;
			object-fit: cover;
		}

		.info {
			width: 100%;
			height: 200px;
			padding: 20px 30px;

			span {
				color: #999;
			}
			p {
				color: #000;
				font-size: 24px;
				height: 68px;
				line-height: 34px;
				margin-top: 20px;
				overflow: hidden;
			}

			.more {
				color: #1265a4;
				font-size: 16px;
				margin-top: 20px;
				display: flex;
				align-items: center;

				.icon {
					color: #fff;
					font-size: 14px;
					width: 20px;
					height: 20px;
					border-radius: 20px;
					background: #1265a4;
					margin-right: 10px;
					display: flex;
					justify-content: center;
					align-items: center;
				}
			}
		}
	}
}
</style>
